<template>
  <a-card :bordered="false" style="margin: -24px -24px 0px;">
    <result type="error" :title="title" :description="description">
      <template slot="action">
        <a-button type="primary" >Return to Modify</a-button>
      </template>
      <div>
        <div style="font-size: 16px; color: rgba(0, 0, 0, 0.85); font-weight: 500; margin-bottom: 16px">
          Your submitted content has the following errors:
        </div>
        <div style="margin-bottom: 16px">
          <a-icon type="close-circle-o" style="color: #f5222d; margin-right: 8px"/>
          Your Account Has Been Frozen
          <a style="margin-left: 16px">Unfreeze Now <a-icon type="right" /></a>
        </div>
        <div>
          <a-icon type="close-circle-o" style="color: #f5222d; margin-right: 8px"/>
          Your account is not eligible to apply
          <a style="margin-left: 16px">Upgrade Now <a-icon type="right" /></a>
        </div>
      </div>
    </result>
  </a-card>
</template>

<script>
import { Result } from '@/components'

export default {
  name: 'Error',
  components: {
    Result
  },
  data () {
    return {
      title: 'SubmitFailed',
      description: 'Please verify and edit the following info, then resubmit.'
    }
  }
}
</script>

<style scoped>

</style>
